import React from 'react';
import { ReportItemConfig } from '../../models';
// utils
import { toEven } from '../../utils';
import { LinkWrapper } from '../BaseComp';

export default (props: { config: ReportItemConfig[] }) => {
    const { config } = props;
    const report = toEven(config);
    return (
        <>
            {
                report.map((item, index) => {
                    if (index !== 0 && index !== 1) {
                        return (
                            <LinkWrapper href={item.link} key={index} style={{ display: 'none' }}>
                                <img src={item.cover} alt={item.label} />
                            </LinkWrapper>
                        );
                    }
                    return (
                        <LinkWrapper href={item.link} key={index}>
                            <img src={item.cover} alt={item.label} />
                        </LinkWrapper>
                    );
                })
            }
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/ReportBanner/ReportBanner.normal.tsx